module.exports = __webpack_public_path__ + "static/media/infinity-group-white.ce09b761.svg";